import React, { useState, useEffect } from "react";
import "./Header.scss";
import { CSSTransition } from "react-transition-group";
import { ReactComponent as Logo } from '../image/logosvg.svg'
import { useHistory } from 'react-router';
import { Link, useLocation } from 'react-router-dom'
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import axios from 'axios';
import { ReactComponent as Cog } from '../image/cog.svg'

const useStyles = makeStyles(theme => ({
    submit: {
        border: '2px solid',
        margin: theme.spacing(3, 0, 2),
      },
    topButton: {
        border: '1px solid #18EA95',
        textDecoration: 'none',
        "&:hover, &:focus": {
            cursor: 'pointer',
            backgroundColor: '#18EA95',
            color: '#FFFFFF'
          }
    },
    root: {
      height: '100vh',
    },
    image: {
      backgroundImage: 'url(https://source.unsplash.com/random)',
      backgroundRepeat: 'no-repeat',
      backgroundColor:
        theme.palette.type === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    paper: {
      margin: theme.spacing(8, 4),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    modal: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
      padding: '70px',
      width: '300px',
      textAlign: 'center'
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    paper: {
        position: 'absolute',
        width: 450,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    buttonForgot: {
      fontSize: '20px',
      textDecoration: 'none',
      "&:hover, &:focus": {
        cursor: 'pointer'
      },
      "&:visited": {
        color: '#FFFFFF'
      }
    },
    searchButton: {
        color: '#18EA95'
    },
    closeButton: { cursor:'pointer', float:'right', marginTop: '5px', width: '20px' },
    inputLabel: {
        color: "#00000",
        fontSize: '20px',
        "&.focused": {
          color: "#18EA95",
          //border: "2px solid #18EA95",
          fontSize: "20px"
        },
        '&.MuiInput-underline:after': {
          borderBottomColor: '#18EA95',
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: "#18EA95",
          },
          '&:hover fieldset': {
            borderColor: "#18EA95",
          },
          '&.Mui-focused fieldset': {
            borderColor: "#18EA95",
          }
        }
      },
      inputLabelProps: {
        color: '#18EA95',
        fontSize: '20px',
        "&.focused": {
          color: "#18EA95",
          //border: "2px solid #18EA95",
          fontSize: "20px"
        },
      },
      underline: {
        color: "#18EA95" ,
        '&::after': {
          border: '2px solid #18EA95'
        }
      }
}));

const encryptBase64Password = (s) => {
  var b = new Buffer(s);
  return b.toString('base64');
}

export default function Header(props) {
    const history = useHistory();
    const classes = useStyles();
    const [isNavVisible, setNavVisibility] = useState(false);
    const [inputChangePassword, setInputChangePassword] = React.useState({})
    const [errorChangePasswordMessage, setErrorChangePasswordMessage] = React.useState('')
    const [open, setOpen] = React.useState(false);
    const [modalStyle] = React.useState(getModalStyle);
    const [infoMessage, setInfoMessage] = React.useState('')
    var username = localStorage.getItem('username') || '';
    function rand() {
        return Math.round(Math.random() * 20) - 10;
      }
    
    function getModalStyle() {
        const top = 50 + rand();
        const left = 50 + rand();
        return {
            top: `${top}%`,
            left: `${left}%`,
            transform: `translate(-${top}%, -${left}%)`,
            zIndex: "2000",
            outline: "none"
        };
      }

    const onLogout = () => {
        history.push('/');
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setInputChangePassword({})
        setErrorChangePasswordMessage('');
        setOpen(false);
    };

    const toggleNav = () => {
        setNavVisibility(!isNavVisible);
    };

    

    const onChangePassword = () => {
        console.log(`password:${inputChangePassword}`)
        if(!inputChangePassword.newpassword || !inputChangePassword.oldpassword || !inputChangePassword.confirmpassword 
          || inputChangePassword.newpassword.trim().length === 0 || inputChangePassword.oldpassword.trim().length === 0
          || inputChangePassword.confirmpassword.trim().length === 0) {
            setErrorChangePasswordMessage('New Password and Confirm Password fields are mandatory.')
            return;
        } 
        
        if(inputChangePassword.newpassword !== inputChangePassword.confirmpassword) {
          setErrorChangePasswordMessage('New Password and Confirm Password must be equal.')
          return;
        }

        var username = localStorage.getItem('username') || '';
        const old_password = encryptBase64Password(inputChangePassword.oldpassword);
        const new_password = encryptBase64Password(inputChangePassword.newpassword);
        const confirm_password = encryptBase64Password(inputChangePassword.confirmpassword);
        axios.post('/api/changepassword', {username,  newpassword: new_password, oldpassword: old_password, confirmpassword: confirm_password }).then((result) => {
          if(!result.data.success) {
              setErrorChangePasswordMessage('Invalid Credentials.')
          }
          if(result.data.success) {
            setErrorChangePasswordMessage('')
            setInfoMessage('Your Password has been changed.')
            setInputChangePassword({})
          }
        })
        
      }

      const handleInputChangePasswordChange = (e) => setInputChangePassword({
        ...inputChangePassword,
        [e.currentTarget.name]: e.currentTarget.value
      })

    return (
        <div>
            <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={open}
                    onClose={handleClose}
                    disableAutoFocus={true}
                    style={{ outline: "none"}}
                    >
                    <div style={modalStyle} className={classes.paper}>
                    <div><span className="text30 colorBlack">Change your password.</span><img onClick={() => handleClose()} src={process.env.PUBLIC_URL + '/image/times.png'} className={classes.closeButton}></img></div>
                    <form className={classes.modal} noValidate>
                        <TextField
                            InputProps={{
                                classes: {
                                  root: classes.inputLabel,
                                }
                              }}
                              InputLabelProps={{
                                classes: {
                                  root: classes.inputLabelProps,
                                  focused: "focused"
                                }
                              }}
                            margin="normal"
                            required
                            fullWidth
                            id="oldpassword"
                            label="Old Password"
                            name="oldpassword"
                            type="password"
                            autoFocus
                            onChange={handleInputChangePasswordChange}
                        />
                        <TextField
                            InputProps={{
                                classes: {
                                  root: classes.inputLabel,
                                }
                              }}
                              InputLabelProps={{
                                classes: {
                                  root: classes.inputLabelProps,
                                  focused: "focused"
                                }
                              }}
                            margin="normal"
                            required
                            fullWidth
                            name="newpassword"
                            label="New Password"
                            id="newpassword"
                            type="password"
                            onChange={handleInputChangePasswordChange}
                        />
                        <TextField
                            InputProps={{
                                classes: {
                                  root: classes.inputLabel,
                                }
                              }}
                              InputLabelProps={{
                                classes: {
                                  root: classes.inputLabelProps,
                                  focused: "focused"
                                }
                              }}
                            margin="normal"
                            required
                            fullWidth
                            name="confirmpassword"
                            label="Confirm Password"
                            id="confirmpassword"
                            type="password"
                            onChange={handleInputChangePasswordChange}
                        />
                        <div className="paddingTop"><div onClick={() => onChangePassword()} className="bodyButton"><div className="hAlign"><span>Change Password</span></div></div></div>
                    </form>
                    { errorChangePasswordMessage !== '' && <div className="error">{errorChangePasswordMessage}</div> }
                    { infoMessage !== '' && <div className="info">{infoMessage}</div> }
                    </div>
                </Modal>
        <nav className="navbar">
        { props.showMenu && <div className="navbar-toggle">
                
                <span  onClick={() => toggleNav()} id="js-navbar-toggle">
                    <Cog width="30" height="30"/>
                </span>
            </div>
        }
            <a href="#" className="logo"><Logo/></a>
            <div style={{ display: "flex" }}>
            { props.showMenu && <div style={{ display: "flex", alignItems: "center" }}><span className="headerUserName">{username}</span></div> }

            { props.showMenu &&
            <div style={{ display: "flex", width: "100%", justifyContent: "flex-end", paddingRight: "10px" }}>
             
            <div className="topMenu">
                
                <ul className={`main-nav ${isNavVisible ? "active" : ""}`} id="js-menu">
                    <li>
                      <span className="headerUserName_resp">{username}</span>
                    </li>
                    <li>
                        <div className="topButton topButton1">
                            <div className="hAlign">
                                <Link onClick={handleOpen} className={classes.buttonForgot} variant="body2">
                                Change Pass
                                </Link>
                            </div>
                        </div>
                        <div className="topButton topButton2" onClick={() => onLogout()}>
                        <div className="hAlign"><span>Logout</span></div></div>
                    </li>
                    <li>
                    
                    </li>
                    {/* <li>
                        <a href="#" className="nav-links">About Us</a>
                    </li>
                    <li>
                        <a href="#" className="nav-links">Contact Us</a>
                    </li>
                    <li>
                        <a href="#" className="nav-links">Blog</a>
                    </li> */}
                </ul>
                </div>
                </div>
            }
            </div>
        </nav>
        </div>

    );
}